<a [routerLink]="['/tour-planner/detail/', _assignment?.assigneeId]" class="jump">
    {{_assignment?.name}} <i [className]="'icon icon-jump-to'"></i>
</a>
({{getResourceLabel()}})